<template>
  <div>
    <section>
      <div class="columns is-hidden-print">
        <div class="column is-hidden-print flex">
          <div class="flex-1">
            <h1 class="title text-md lg:text-2xl" v-text="nameWithId"></h1>
            <h2 class="subtitle text-sm lg:text-base">
              <span class="icon"><i class="fas fa-calendar-alt"></i></span>
              <span class="mr-4 mb-4 is-inline-block">{{
                `${formatTime(meeting.start_date)} - ${formatTime(
                  meeting.end_date
                )}`
              }}</span>
              <span
                v-text="currentPhase.text"
                class="is-hidden-print"
                :class="[
                  'tag',
                  'has-text-weight-bold',
                  'is-uppercase',
                  this.currentPhase.style
                ]"
              >
              </span>
              <span
                v-if="meeting.is_archived"
                class="is-hidden-print"
                :class="[
                  'tag',
                  'haas-text-weight-bold',
                  'is-uppercase',
                  'is-black'
                ]"
              >
                Archived
              </span>
            </h2>
          </div>
          <div class="flex justify-end lg:hidden pl-3 is-hidden-print">
            <button
              type="button"
              class="button is-primary"
              @click.prevent="sideBarOpen = !sideBarOpen"
            >
              <span class="icon" aria-hidden="true"
                ><i class="fas fa-ellipsis-v"></i
              ></span>
              <span>Menu</span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <div class="columns mt-4">
      <div class="column is-one-quarter is-hidden-print hidden lg:block">
        <MeetingMenu
          :pageId="id"
          :meeting="meeting"
          :currentPhase="currentPhase"
        />
      </div>

      <main class="main mb-8 column">
        <router-view></router-view>
      </main>

      <div>
        <form :action="functionUrl" method="post" ref="formExportUsers">
          <input v-show="false" name="token" v-model="token" />
          <input v-show="false" name="meetingId" v-model="id" />
          <input v-show="false" name="userInfo" v-model="userInfo" />
        </form>
      </div>
    </div>

    <b-sidebar
      v-model="sideBarOpen"
      :fullheight="true"
      :fullwidth="false"
      :overlay="true"
      :right="true"
    >
      <MeetingMenu
        :pageId="id"
        :meeting="meeting"
        :currentPhase="currentPhase"
        class="p-4"
      />
    </b-sidebar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import eventHub from '@/event-hub';
import swal from 'sweetalert';
import { db, firebase } from '@/services/firebase';
import dbhelpers from '@/services/dbhelpers';
import { phases } from '@/services/meeting';
import { firestoreTimestampToDate } from '@/services/utils';
import maxxAPI from '@/services/maxxapi';
import MeetingMenu from '@/components/meeting/MeetingMenu';

export default {
  props: ['id'],

  components: { MeetingMenu },

  data() {
    return {
      meeting: {},
      phases: phases,
      token: '',
      userInfo: {},
      functionUrl: `${process.env.FIREBASE_FUNCTIONS_DOMAIN}/exportUsers`,
      sideBarOpen: false
    };
  },

  computed: {
    ...mapGetters(['meetingSuites']),
    currentPhase() {
      if (!this.meeting.phase_index) return this.phases[0];
      return this.phases[this.meeting.phase_index];
    },
    nameWithId() {
      return this.meeting
        ? `${this.meeting.name} (Maxx ID: ${this.meeting.maxxId})`
        : '';
    }
  },

  watch: {
    meeting(newValue, oldValue) {
      if (oldValue.maxxId !== newValue.maxxId) {
        maxxAPI.getMeetingRegistrations(newValue.maxxId).then(data => {
          this.$store.commit('setMeetingRegistrations', data);
        });
      }
    }
  },

  created() {
    dbhelpers.getAllMeetingSuites(this.id);
    eventHub.$on('runScheduleExport', this.runScheduleExport);
    eventHub.$on('runUsersExport', this.runUsersExport);
    eventHub.$on('advancePhase', this.advancePhase);
    eventHub.$on('toggleArchived', this.toggleArchived);
  },

  beforeDestroy() {
    eventHub.$off('runScheduleExport', this.runScheduleExport);
    eventHub.$off('runUsersExport', this.runUsersExport);
    eventHub.$off('advancePhase', this.advancePhase);
    eventHub.$off('toggleArchived', this.toggleArchived);
  },

  methods: {
    formatTime: firestoreTimestampToDate,
    advancePhase() {
      swal({
        title: 'Are you sure?',
        text: this.currentPhase.alertText,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Cancel',
            value: null,
            visible: true,
            className: 'button is-light',
            closeModal: true
          },
          confirm: {
            text: 'Continue',
            value: true,
            visible: true,
            className: 'button is-primary',
            closeModal: true
          }
        },
        dangerMode: true
      }).then(proceed => {
        if (proceed) {
          let newIndex = 0;

          if (this.meeting.phase_index < 2) {
            newIndex = this.meeting.phase_index + 1;
          }

          this.$firestoreRefs.meeting.update({ phase_index: newIndex });
        }
      });
    },
    toggleArchived() {
      this.$firestoreRefs.meeting.update({
        is_archived: !this.meeting.is_archived
      });
    },
    runScheduleExport() {
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(token => {
          window.location = `${process.env.FIREBASE_FUNCTIONS_DOMAIN}/exportActivity?meetingId=${this.id}&token=${token}`;
        });
    },
    runUsersExport() {
      let suites = this.meetingSuites;
      let contacts = [];
      Object.keys(suites).forEach(suiteKey => {
        let suite = suites[suiteKey];
        if (suite.contacts) {
          let contact = suite.contacts;
          if (contact.length) {
            contact.forEach(singleContact => {
              contacts.push(singleContact.username);
            });
          }
        }
      });
      maxxAPI
        .getIndividuals(contacts)
        .then(userInfo => {
          this.userInfo = userInfo;
        })
        .then(() => {
          return firebase.auth().currentUser.getIdToken();
        })
        .then(token => {
          this.token = token;
        })
        .then(() => {
          this.$refs.formExportUsers.submit();
        })
        .catch(error => {
          console.log(error);
          if (error === 'No user') {
            swal({
              title: 'No MatrixMaxx session',
              text:
                'Your MatrixMaxx session is no longer active. Please login to continue with this export.',
              icon: 'error'
            });
          } else {
            swal({
              title: 'Unknown error',
              text: 'The export has failed',
              icon: 'error'
            });
          }
        });
    }
  },

  firestore() {
    return {
      meeting: db.collection('meetings').doc(this.id)
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/MeetingDashboard.vue